import React from "react";
import styles from "../styles/AuthHeader.module.css";

const AvatarMenuItem = ({ onClick, menuItem, isActive, isMobile, showIcon }) => {

	return (
		<div
			onClick={onClick}
			className={`${styles.avatarMenuOption} ${isMobile ? styles.mobile : ''} ${isActive ? styles.active : ''}`}
		>
			<div className="d-flex align-items-center gap-8">
				{showIcon ? menuItem.icon : null}

				{menuItem.labelComponent || <span className="tt-16 medium color-black mb-0">{menuItem.label}</span>}
			</div>
		</div>
	);
}

export default AvatarMenuItem;